import { c as _c } from "react/compiler-runtime";
import { Divider, Stack } from '@mui/material';
import { useRef, type UIEventHandler } from 'react';
import { Icon } from '@/components/shared/icon';
export const SelectedItemsBody = t0 => {
  const $ = _c(16);
  const {
    items,
    renderItem,
    itemKey,
    onRemove,
    onScrollVerticallyChange
  } = t0;
  const isScrolledVertically = useRef(false);
  let t1;
  if ($[0] !== onScrollVerticallyChange) {
    t1 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically.current) {
          isScrolledVertically.current = isScrolled;
          onScrollVerticallyChange?.(isScrolled);
        }
      }
    };
    $[0] = onScrollVerticallyChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onScroll = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider sx={{
      paddingY: "2px"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = onScrollVerticallyChange ? onScroll : undefined;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flexGrow: 1,
      overflow: "auto",
      height: "auto",
      gap: "8px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== itemKey || $[5] !== items || $[6] !== onRemove || $[7] !== renderItem) {
    let t6;
    if ($[9] !== itemKey || $[10] !== onRemove || $[11] !== renderItem) {
      t6 = item => <Stack direction="row" key={itemKey(item)} className="px-[24px]" sx={{
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between"
      }}>{renderItem(item)}<Icon onClick={() => onRemove(item)} iconClass="material-symbols-close-rounded" /></Stack>;
      $[9] = itemKey;
      $[10] = onRemove;
      $[11] = renderItem;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t5 = items.map(t6);
    $[4] = itemKey;
    $[5] = items;
    $[6] = onRemove;
    $[7] = renderItem;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <Stack className="py-[12px]" divider={t2} onScroll={t3} sx={t4}>{t5}</Stack>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};